<svg height="19.137" viewBox="0 0 19 19.137" width="19" xmlns="http://www.w3.org/2000/svg">
	<path d="m86.485 19.136v-8.718h2.977l.425-3.4h-3.4v-2.128c0-.957.319-1.7 1.7-1.7h1.807v-3.084c-.426 0-1.494-.106-2.659-.106a4.1 4.1 0 0 0 -4.359 4.465v2.551h-2.976v3.4h2.977v8.717z" fill="unset" transform="translate(-75.261 .001)"/>
</svg>
